export const spacings = {
  xxs: '4px',
  xs: '8px',
  sm: '12px',
  md: '16px',
  xm: '18px',
  lg: '30px',
  xl: '40px'
}
